import { FC } from 'react'
import { Box, Flex } from '@/components/atoms/Grid'
import { Small2 } from '@/components/atoms/typography'
import { IconButtonCapitalized } from '@/components/molecules/iconButtons'
import { transparentize } from 'polished'
import { FacebookCircleIconDefault } from '@/components/atoms/icons/FacebookCircleIconDefault'
import { TwitterIconDefault } from '@/components/atoms/icons/TwitterIconDefault'
import styled from 'styled-components'
import useTranslation from 'next-translate/useTranslation'

const PostDetailSocialBlock: FC = () => {
  const { t } = useTranslation('common')

  const shareFacebook = () => {
    const href = `${window.location.href}`
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(href)}`
    )
  }

  const shareTwitter = () => {
    const href = `${window.location.href}`
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(href)}`
    )
  }

  return (
    <Box alignSelf="flex-start">
      <Small2 mb={2}>{t('Blog.share')}:</Small2>
      <SocialIcons>
        <FacebookButton
          IconElement={<FacebookCircleIconDefault width={16} height={16} />}
          onClick={shareFacebook}
        />
        <TwitterButton
          IconElement={<TwitterIconDefault width={16} height={16} />}
          onClick={shareTwitter}
        />
      </SocialIcons>
    </Box>
  )
}

export default PostDetailSocialBlock

const SocialIcons = styled(Flex)`
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  width: 90px;
  height: 30px;
  border: 1px solid
    ${(props) => transparentize(0.7, props.theme.colors.neutralBorder)};
  border-radius: 2px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 49.5%;
    height: 100%;
    width: 1px;
    background-color: ${(props) =>
      transparentize(0.7, props.theme.colors.neutralBorder)};
  }
`

const FacebookButton = styled(IconButtonCapitalized)`
  border: 0;
  width: 45px;
  height: 30px;
  transition: all 0.125s ease-in;
  & g {
    fill: ${(props) => props.theme.colors.onBackground};
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.facebook};
    & g {
      fill: ${(props) => props.theme.colors.background};
    }
  }
`

const TwitterButton = styled(IconButtonCapitalized)`
  border: 0;
  width: 45px;
  height: 30px;
  transition: all 0.125s ease-in;
  & g {
    fill: ${(props) => props.theme.colors.onBackground};
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.twitter};
    & g {
      fill: ${(props) => props.theme.colors.background};
    }
  }
`
